export class TypeNatureMarcheLot {

	public travaux: string;

	public fournitures: string;

	public services: string;

	constructor() { 
		 		this.travaux = '';
		this.fournitures = '';
		this.services = '';
 
	}
}
